module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-full flex flex-col space-y-2 px-2 py-2"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_genie_feedback === false),
      expression: "show_genie_feedback === false"
    }],
    staticClass: "h-full",
    attrs: {
      "id": "prompt-editor"
    }
  }, [_c('PromptEditor', {
    attrs: {
      "id": "prompt-written",
      "init": _vm.editorOptions,
      "api-key": "no-api-key",
      "value": _vm.prompt_adjusted_with_links
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_genie_feedback === true),
      expression: "show_genie_feedback === true"
    }],
    staticClass: "genie-feedback h-full html-genie-content"
  }, [(_vm.genie_feedback.overall_feedback !== '') ? _c('div', {
    staticClass: "rounded"
  }, [_c('div', {
    staticClass: "flex justify-between items-center px-3 mb-2"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "w-7 h-7 bg-blueGray-50 border border-solid hover:bg-blueGray-100 text-blueGray-600 hover:text-blueGray-700 border-blueGray-600 rounded-full",
    on: {
      "click": function($event) {
        return _vm.handleRegenerateGenieFeedback()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid text-sm fa-rotate",
    class: _vm.is_regenerating === true ? 'animate-spin' : ''
  })])]), _vm._v(" "), (_vm.is_regenerating === true) ? _c('div', {
    staticClass: "w-full"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "w-full bg-white rounded flex flex-col h-full overflow-y-auto"
  }, [_c('div', {
    staticClass: "flex-1 overflow-y-auto px-3 py-2 space-y-4"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-2"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-3"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "font-manrope text-gray-800 text-sm font-light"
  }, [_vm._v("\n                " + _vm._s(_vm.genie_feedback.overall_feedback) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "border-b border-gray-200 mt-3 mb-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-2 py-4 px-3"
  }, [_c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('i', {
    staticClass: "fa-regular fa-thumbs-up text-xl text-blue-500"
  }), _vm._v(" "), (_vm.is_regenerating === true) ? _c('div', {
    staticClass: "w-32 genie-background"
  }) : _c('h6', {
    staticClass: "font-manrope font-semibold text-gray-800 text-base"
  }, [_vm._v("\n              Strengths\n            ")])]), _vm._v(" "), _vm._l((_vm.genie_feedback.strengths), function(strength) {
    return _c('ul', {
      staticClass: "list-disc ml-5 text-sm font-manrope text-gray-800"
    }, [_c('li', [_vm._v(_vm._s(strength))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-2 px-3 py-4 mb-5"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.genie_feedback.improvments), function(improvment) {
    return _c('ul', {
      staticClass: "list-disc ml-5 text-sm font-manrope text-gray-800"
    }, [_c('li', [_vm._v(_vm._s(improvment))])])
  })], 2)])]) : _c('div', {
    staticClass: "w-full h-full flex flex-col justify-center items-center space-y-5"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-center space-x-2"
  }, [_c('button', {
    staticClass: "px-3 rounded py-2 bg-pinky flex items-center space-x-2 hover:bg-pinky-dark text-white border border-solid border-pinky",
    on: {
      "click": function($event) {
        return _vm.handleStartGenerateFeedback()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.is_generating_feedback === true ? 'Generating' : 'Generate Feedback'))]), _vm._v(" "), (_vm.is_generating_feedback === true) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()])])])]), _vm._v(" "), (_vm.show_genie_feedback === false) ? _c('div', {
    staticClass: "flex justify-end items-center"
  }, [(_vm.getCurrentRT.enable_grading && _vm.getCurrentRT.points_settings.peer_rewards.length) ? _c('ViewCriteriaModal', {
    attrs: {
      "rewards": _vm.getCurrentRT.points_settings.peer_rewards,
      "criteriaScale": Number(_vm.getCurrentRT.point_cap)
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "font-manrope text-xs text-gray-800 flex items-center space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info"
  }), _vm._v(" "), _c('span', [_vm._v("Genie’s feedback is AI-generated and still in beta. It can help refine your ideas, but your own judgment matters most.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-start space-x-3 mt-3"
  }, [_c('div', {
    staticClass: "w-full flex flex-col animate-pulse space-y-3"
  }, [_c('div', {
    staticClass: "h-4 genie-background rounded w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-4 genie-background rounded w-7/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-4 genie-background rounded w-10/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-4 genie-background rounded w-7/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-4 genie-background rounded w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-4 genie-background rounded w-10/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-4 genie-background rounded w-8/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-4 genie-background rounded w-6/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-4 genie-background rounded w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-4 genie-background rounded w-4/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-4 genie-background rounded w-9/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-4 genie-background rounded w-full"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex justify-between items-center space-x-3"
  }, [_c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('i', {
    staticClass: "fa-regular text-xl fa-comment text-blueGray-800"
  }), _vm._v(" "), _c('h6', {
    staticClass: "font-manrope font-semibold text-gray-800 text-lg"
  }, [_vm._v("\n                    General Feedback\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('i', {
    staticClass: "fa-solid fa-rocket text-orange-500 text-xl"
  }), _vm._v(" "), _c('h6', {
    staticClass: "font-manrope font-semibold text-gray-800 text-base"
  }, [_vm._v("\n              Opportunities for Improvement...\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex justify-center items-center space-x-3"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": "/static/roundtable_options_create/genie_icon.svg"
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "font-poppins font-semibold text-xl text-gray-700"
  }, [_vm._v("Genie Feedback")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-32 font-poppins text-blueGray-800 text-center"
  }, [_c('div', [_vm._v("\n          The Genie "), _c('b', {
    staticClass: "font-semibold"
  }, [_vm._v("analyzes your response")]), _vm._v(" in real time, compares it to "), _c('b', {
    staticClass: "font-semibold"
  }, [_vm._v("predefined standards and provides constructive")]), _vm._v(" feedback. It highlights "), _c('b', {
    staticClass: "font-semibold"
  }, [_vm._v("strengths, identifies areas for improvement and offers actionable suggestions")]), _vm._v(" to enhance learning outcomes.\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5be88655!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/tabs/promptTab.vue
// module id = 1293
// module chunks = 61